<div id="catList"  class="container" *ngIf="!display">
  <mat-list   *ngFor="let item of categoryList; let i = index"
    [ngClass]="{'accordion-list':item.subcategories.length ==0,'':item.subcategories.length >0}" lines="none"
    class="child-list" detail="false" no-padding menuClose>

    <div matRipple tappable

      [ngClass]="{'section-active': item.open, 'section': !item.open}">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <mat-label fxFlex="80"  (click)="productList(item , item.subcategories.length)" color="dark" class="itemLabel padding-10">
          {{ item.categoryName }}
        </mat-label>
        <mat-icon  (click)="toggleSection(i)" matSuffix *ngIf="item.subcategories.length >0 && item.open !=true">arrow_right</mat-icon>
        <mat-icon (click)="toggleSection(i)" class="iconClr" *ngIf="item.open ==true">arrow_drop_down</mat-icon>
      </div>
    </div>
    <div *ngIf="item.subcategories && item.open" menuClose>
      <mat-list *ngFor="let child of item.subcategories; let j = index" lines="none" class="child-list">
        <div tappable
          *ngIf="child.subcategories" [ngClass]="{'child-active': !child.open, 'child': child.open}">
          <mat-label>

            <div fxLayout="row" fxLayoutAlign="space-between none" matRipple class="cName padding-10 padding-l40">
              <span class="itemLabel" (click)="productList(child , child.subcategories.length)"> {{ child.categoryName }}</span>
              <mat-icon  (click)="toggleItem(i, j)"  class="micon" matSuffix *ngIf="child.subcategories.length >0 && child.open !=true">
                add
              </mat-icon>
              <mat-icon  (click)="toggleItem(i, j)" class="micon" *ngIf="child.open ==true">minimize</mat-icon>
            </div>
            <!-- <div matRipple style="align-content: center;padding: 10px; padding-left: 40px;">


        </div> -->

          </mat-label>

        </div>


        <div *ngIf="child.subcategories && child.open" class="product-list" lines="none">
          <mat-list class="child" *ngFor="let subChild of child.subcategories; let k = index" lines="none"
            class="child-list">
            <div tappable
             [ngClass]="{'child-active': !child.open, 'child': child.open}">
              <mat-label>
                <div (click)="productList(subChild , subChild.subcategories.length)" matRipple class=" itemLabel subchild padding-10 padding-l50">
                  {{ subChild.categoryName }}
                </div>
              </mat-label>

              <calsoft-nested-side-menu-child [child]="subChild"></calsoft-nested-side-menu-child>
            </div>
          </mat-list>
        </div>
      </mat-list>
    </div>

  </mat-list>

</div>
<div *ngIf="display"    class="padding-10" >
  <div id="noProducts" fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
      <div>
        <img src="assets/images/no-product.png" alt="no-product">
      </div>
      <div class="notFound">
        <span>Sorry, no results found! </span>
      </div>
      <div class="spell">
        <span fxLayoutAlign="center center">Please check the spelling or try searching for something else </span>
      </div>
    </div>
  </div>
</div>
